import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import moment from 'moment';

import ActiveTripsTable from '../../components/ActiveTripsTable';

import '../../styles/dashboard.css';
import UpcomingTripsTable from '../../components/UpcomingTripsTable';

export default class UpcomingTrips extends Component {
  constructor() {
    super();
    this.state = {
      users: 0,
      filter: null,
    };
  }

  componentDidMount() {
    
  }

  componentWillReceiveProps() {
    this.setState({ filter: null });
  }

  applyFilters(e) {
    e.preventDefault();

    const from = this.startDate;
    const to = this.endDate;
    if (from && to) this.setState({ filter: { from, to } });
  }

  render() {
    const user = this.props.user;
    // if we have a user session we redirect away from sign up
    if (!user || !user.id) {
      return (
        <Redirect to={{
          push: true,
          rtURL: '/users',
          rtProps: this.props.location.state,
          pathname: '/login',
        }}
        />
      );
    }
    return (
      <div className="user-dash-wrapper">
        <div className="clearfix" />
        <div className="sub-page-header col-sm-12">
          <h2>Upcoming Trips for Today</h2>
        </div>

        <div className="col-md-12 col-lg-12">

          <div className="module focus green">
            <div className="module-header" />
            <UpcomingTripsTable filter={this.state.filter} setDashboardMessage={this.props.setDashboardMessage} />
          </div>
        </div>

      </div>
    );
  }
}


UpcomingTrips.propTypes = {
  user: PropTypes.object,
  location: PropTypes.shape({
    state: PropTypes.object,
  }),
};

UpcomingTrips.defaultProps = {
  user: null,
  location: {
    state: {},
  },
  setDashboardMessage: () => { },
};
